export function isSubarray(subarray, array) {
    const sortedSubarray = subarray.slice().sort();
    const sortedArray = array.slice().sort();

    let i = 0;
    return sortedArray.some((element) => {
        if (element === sortedSubarray[i]) {
            i++;
        }
        return i === sortedSubarray.length;
    });
}

export function getSectionNameFromSection(section, qNo) {
    if (section.sectionNo == qNo || section.no == qNo) {
        return section.sectionName || section.name;
    }

    if (section.subFolders) {
        for (const subFolder of Object.values(section.subFolders)) {
            const result = getSectionNameFromSection(subFolder, qNo);
            if (result != "") return result;
        }
    }

    return "";
}

export function getSectionName(module, qNo) {
    if (qNo == "DXXX" || qNo == "SXXX") return "Unallocated Bin";

    const sections = module?.sections || module?.tempSections || [];
    for (const section of sections) {
        const sectionName = getSectionNameFromSection(section, qNo);
        if (sectionName != "") return sectionName;
    }

    return "Unknown";
}

export function getFilesFromQuestions(questions) {
    return questions && questions.filter(q => q.answer?.files?.length)
        .reduce((arr, q) => [...arr, ...q.answer.files.map(file => ({
            ...file,
            questionId: q._id,
            title: file.originalname,
            url: file.location,
            ext: file.originalname.split(".").slice(-1)[0],
        }))], []);
}

export function sortQuestions(a, b, tab) {
    if (tab && tab == 'investor-lead' && (a.qNo.split('.').length > 3 || b.qNo.split('.').length > 3)) {
        let valueA = a.qNo.split('.')[a.qNo.split('.').length - 2];
        let valueB = b.qNo.split('.')[a.qNo.split('.').length - 2];
        return valueA - valueB;
    }

    let valueA = a.qNo.split('.')[a.qNo.split('.').length - 1];
    let valueB = b.qNo.split('.')[a.qNo.split('.').length - 1];
    return valueA - valueB;
}
